<div class="text-center hero my-5">
  <img class="mb-3 app-logo" src="../../assets/logo.png" alt="Angular logo" />
  <h1 class="mb-4">MotorTwin</h1>

  <p class="lead">
    The engineering solver application from
    <a href="https://www.tinarmengineering.com/">Tin Arm</a>
  </p>
</div>